export function excerptOf(text: string, maxCharacters: number): string {
  const trimmed = text.trim();
  return trimmed.length <= maxCharacters ? trimmed : `${trimmed.slice(0, maxCharacters - 1).trimEnd()}…`;
}
